import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { DownloadConfig, DownloadType, translationKeys } from '../../../core';

@Component({
  selector: 'scip-download-dialog',
  templateUrl: './download-dialog.component.html',
  styleUrls: ['./download-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadDialogComponent {
  @Output() readonly downloadEvent: EventEmitter<DownloadConfig> = new EventEmitter<DownloadConfig>();
  @Output() readonly cancelEvent: EventEmitter<void> = new EventEmitter<void>();
  showDialog = true;
  translationKeys: typeof translationKeys = translationKeys;
  DownloadType = DownloadType;
  downloadConfig: DownloadConfig = {
    downloadType: DownloadType.CurrentPage
  };

  onDownload(): void {
    this.downloadEvent.emit(this.downloadConfig);
  }
}
